module.exports = __webpack_public_path__ + "img/youngfactorlogo.f74c5e7f.png";